import React from 'react';
import { Link } from 'react-router-dom';

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      openDropdowns: {},
    };
  }

  toggleCollapse() {
    const next = !this.state.collapsed;
    this.setState({ collapsed: next });
    const body = document.body;
    if (next) {
      body.classList.add('sidebar-collapse');
    } else {
      body.classList.remove('sidebar-collapse');
    }
  }

  toggleDropdown(index) {
    this.setState(prev => ({
      openDropdowns: {
        ...prev.openDropdowns,
        [index]: !prev.openDropdowns[index],
      },
    }));
  }

  componentDidUpdate(prevProps) {
    // Auto-abre dropdown do item ativo ao mudar de rota
    if (prevProps.path !== this.props.path) {
      const newOpen = {};
      this.props.links.forEach((link, i) => {
        if (link.tipo === 'dropdown') {
          const isActive = link.sublinks.some(s => s.rota === this.props.path);
          if (isActive) newOpen[i] = true;
        }
      });
      this.setState({ openDropdowns: newOpen });

      // Fecha sidebar no mobile ao navegar
      if (window.innerWidth <= 767) {
        document.body.classList.remove('sidebar-open');
      }
    }
  }

  componentDidMount() {
    // Abre dropdown do item ativo na carga inicial
    const newOpen = {};
    this.props.links.forEach((link, i) => {
      if (link.tipo === 'dropdown') {
        const isActive = link.sublinks.some(s => s.rota === this.props.path);
        if (isActive) newOpen[i] = true;
      }
    });
    this.setState({ openDropdowns: newOpen });

    // Escuta o evento do botão hamburguer do Header
    this._onToggle = () => this.toggleCollapse();
    window.addEventListener('alpha-toggle-sidebar', this._onToggle);
  }

  componentWillUnmount() {
    window.removeEventListener('alpha-toggle-sidebar', this._onToggle);
  }

  render() {
    const { collapsed, openDropdowns } = this.state;
    const { links, path } = this.props;

    return (
      <aside className={`alpha-sidebar${collapsed ? ' alpha-sidebar--collapsed' : ''}`}>
        {/* Logo no topo da sidebar */}
        <div className="alpha-sidebar-logo">
          <img className="alpha-sidebar-logo-full" src="/images/Logo alpha convites.png" alt="Alpha" />
          <img className="alpha-sidebar-logo-mini" src="/images/Logo alpha convites.png" alt="Alpha" />
        </div>

        <nav className="alpha-sidebar-nav">
          <ul className="alpha-menu">
            {links.map((link, i) => {
              if (link.tipo === 'header') {
                return (
                  <li key={'h' + i} className="alpha-menu-header">
                    <span>{link.span}</span>
                  </li>
                );
              }

              if (link.tipo === 'unico') {
                const isActive = path === link.rota;
                return (
                  <li key={'l' + i} className={`alpha-menu-item${isActive ? ' alpha-menu-item--active' : ''}`}>
                    <Link to={link.rota} className="alpha-menu-link" title={collapsed ? link.span : ''}>
                      <span className="alpha-menu-icon">
                        <i className={`fa ${link.icone}`}></i>
                      </span>
                      <span className="alpha-menu-label">{link.span}</span>
                      {collapsed && (
                        <span className="alpha-tooltip">{link.span}</span>
                      )}
                    </Link>
                  </li>
                );
              }

              if (link.tipo === 'dropdown') {
                const hasActive = link.sublinks.some(s => s.rota === path);
                const isOpen = openDropdowns[i] || false;

                return (
                  <li key={'l' + i} className={`alpha-menu-item alpha-menu-item--dropdown${hasActive ? ' alpha-menu-item--active' : ''}${isOpen ? ' alpha-menu-item--open' : ''}`}>
                    <button
                      className="alpha-menu-link alpha-menu-link--dropdown"
                      onClick={() => this.toggleDropdown(i)}
                      title={collapsed ? link.span : ''}
                    >
                      <span className="alpha-menu-icon">
                        <i className={`fa ${link.icone}`}></i>
                      </span>
                      <span className="alpha-menu-label">{link.span}</span>
                      <svg className={`alpha-arrow${isOpen ? ' alpha-arrow--open' : ''}`} width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M3 4.5l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {collapsed && (
                        <span className="alpha-tooltip">{link.span}</span>
                      )}
                    </button>

                    <ul className={`alpha-submenu${isOpen ? ' alpha-submenu--open' : ''}`}>
                      {link.sublinks.map((sublink, j) => {
                        const subActive = path === sublink.rota;
                        return (
                          <li key={'s' + i + j} className={`alpha-submenu-item${subActive ? ' alpha-submenu-item--active' : ''}`}>
                            <Link to={sublink.rota} className="alpha-submenu-link">
                              <span className="alpha-submenu-icon">
                                <i className={`fa ${sublink.icone}`}></i>
                              </span>
                              <span>{sublink.span}</span>
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                );
              }

              return null;
            })}
          </ul>
        </nav>
      </aside>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js